<template>
  <FashionTile
    :fashion="post"
    :fashionImage="fashionImage"
    :settings="settings"
    :popupSettings="popupSettings"
    :hasPrevPost="hasPrevPost"
    :hasNextPost="hasNextPost"
    @changePostRequest="
      (direction) => (direction > 0 ? popupNext() : popupPrev())
    "
    titleMode="postsCount"
  >
    <template v-slot:imageArea>
      <span
        v-if="settings.isShowDescriptionAbovePreview && description"
        class="frisbuy-outfit-on-model-item__description"
      >
        {{ description }}
      </span>
    </template>
  </FashionTile>
</template>

<style scoped lang="scss">
.frisbuy-outfit-on-model-item__description {
  position: absolute;

  top: -24px;
  left: 0;
  width: 100%;

  text-align: center;

  overflow-wrap: break-word;
  overflow: hidden;

  color: #2e353b;

  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 400;

  padding-bottom: 4px;
}

.frisbuy-video-wrapper {
  padding-bottom: 100%;
}
</style>

<script>
import FashionTile from "../components/FashionTile.vue";
import defaultShopTheLookProductPopup from "../ProductPopup/ProductPopup.vue";

export default {
  extends: defaultShopTheLookProductPopup,

  components: {
    FashionTile,
  },

  mounted() {
    this.unlockWindowScroll();
  },

  computed: {
    description() {
      return this.post.frisbuyPost.text;
    },
  },
};
</script>
